/**
 * GENERATED by `bun run scripts/sync-field-labels.ts`. Do not edit.
 *
 * @remarks
 * The API English label of every request field whose label differs from its humanized wire name, which the form prints on an English page and wherever a translated payload carries no label of its own.
 */
export const EN_FIELD_LABELS: Record<string, string> = {
	afterSunset: 'Born after sunset',
	allowDuplicates: 'Allow duplicate cards',
	allowReversals: 'Allow reversed cards',
	angelDating: 'How the name of the day is dated',
	annualFromYear: 'Annual pillars from year',
	annualYears: 'Years of annual pillars',
	approximateDate: 'Approximate date',
	aspectTypes: 'Aspect types',
	atbashOutput: 'AtBash and Albam output',
	avasthaInfo: 'Include avastha details',
	avoidAnimal: 'Avoid clashes with',
	ayadiText: 'Ayadi text family',
	ayanamsaValue: 'Custom ayanamsa value',
	birthData: 'Birth details',
	birthDate: 'Birth date',
	birthLatitude: 'Birth latitude',
	birthLongitude: 'Birth longitude',
	birthTime: 'Birth time',
	ciphers: 'Ciphers to return',
	context: 'Where you saw it',
	coordinateSystem: 'Coordinate system',
	correlation: 'Correlation constant',
	count: 'How many',
	currentYear: 'Current year',
	cuts: 'Cut corners',
	dasha: 'Dasha lords',
	datetime: 'Date and time',
	dayBoundary: 'Day boundary',
	depth: 'Depth, north to south',
	directionScheme: 'Direction reading',
	division: 'Divisional chart',
	domainWeights: 'Domain weights',
	door: 'Door coordinates',
	doorPosition: 'Door position along the side',
	doshaClock: 'How the dosha periods are cut',
	endDate: 'End date',
	endDatetime: 'End date and time',
	expression: 'Expression number',
	extensions: 'Extended corners',
	facing: 'Facing direction',
	facingDegrees: 'Facing degrees',
	family: 'Yoga family',
	firstName: 'First name',
	firstNameHebrew: 'First name in Hebrew',
	fullName: 'Full name',
	gainHouses: 'Gain houses',
	grid: 'Mandala grid',
	hastaInches: 'Length of one hasta in inches',
	horaryNumber: 'Horary number',
	hourClock: 'Hour clock',
	houseSystem: 'House system',
	id: 'ID',
	include: 'Additional bodies',
	includeMatches: 'Include equal value matches',
	interpretation: 'Position meaning',
	intervalMinutes: 'Interval in minutes',
	isLeapMonth: 'Leap month',
	iso2: 'Country code',
	kua: 'Kua number',
	lang: 'Language',
	latinCiphers: 'Also score the Latin ciphers',
	leapDayPolicy: 'Where 29 February falls',
	letter: 'Starting letter',
	letterAttribution: 'Letter attribution reading',
	lifePath: 'Life Path number',
	limit: 'Results per page',
	lines: 'Line pattern',
	lossHouses: 'Loss houses',
	lunarDay: 'Lunar day',
	lunarMonth: 'Lunar month',
	lunarYear: 'Lunar year',
	members: 'Group members',
	minSignificance: 'Minimum significance',
	minStrength: 'Minimum strength',
	misparGadol: 'Mispar gadol method',
	modernPlanets: 'Include modern planets',
	moonWindows: 'Moon windows',
	muhurtaText: 'Muhurta text',
	nameHebrew: 'Name in Hebrew',
	natalChart: 'Natal chart',
	nodeType: 'Lunar node type',
	offset: 'Results to skip',
	polygon: 'Outline',
	positions: 'Spread positions',
	q: 'Search',
	question: 'Your question',
	relocationLatitude: 'Relocation latitude',
	relocationLongitude: 'Relocation longitude',
	returnDate: 'Return date',
	returnYear: 'Return year',
	ritucharyaScheme: 'Season division',
	rituZodiac: 'Zodiac the season boundaries are measured in',
	road: 'Road side',
	rulingPlanets: 'Ruling planets',
	scheme: 'Karaka scheme',
	secondName: 'Second name',
	secondNameHebrew: 'Second name in Hebrew',
	sephirotSystem: 'Sephirot reading',
	sign: 'Zodiac sign',
	sign1: 'First animal sign',
	sign2: 'Second animal sign',
	signDoshaScheme: 'Sign humour table',
	significators: 'Include KP significators',
	slopeLowDirection: 'Direction the ground falls toward',
	slopeSchool: 'Ground level school',
	soulUrge: 'Soul Urge number',
	spreadName: 'Spread name',
	startDate: 'Start date',
	startDatetime: 'Start date and time',
	strictOrbs: 'Use tighter orbs',
	system: 'Avastha system',
	targetDate: 'Target date',
	targetMonth: 'Target month',
	text: 'Word or name',
	textHebrew: 'Hebrew word or name',
	top: 'Top events per window',
	transitDate: 'Transit date',
	transitTime: 'Transit time',
	transliteration: 'Transliteration scheme',
	treeVariant: 'Tree arrangement',
	type: 'Pattern type',
	vyayaFormula: 'Vyaya formula',
	water: 'Standing water direction',
	weights: 'Layer weights',
	width: 'Width, east to west',
	x: 'Distance east',
	y: 'Distance north',
	yearBearerSystem: 'Year Bearer school',
	yearBoundary: 'Year boundary',
	yearStart: 'Wheel year start',
	zodiac: 'Zodiac sign',
};
